import { queryOptions } from "@tanstack/react-query";
import { stockApi } from "./api.ts";
import type { WarehouseCode } from "./types.ts";

// Ключи склада начинаются с "stock": после любого движения экран
// сбрасывает их разом, остатки и очереди не расходятся.
export const STOCK = ["stock"] as const;

export const shelfQuery = (code: string) =>
  queryOptions({ queryKey: [...STOCK, "shelf", code], queryFn: () => stockApi.shelf(code), retry: false });

export const countQuery = (code: string) =>
  queryOptions({ queryKey: [...STOCK, "count", code], queryFn: () => stockApi.countView(code), retry: false });

export const productQuery = (sku: string) =>
  queryOptions({ queryKey: [...STOCK, "product", sku], queryFn: () => stockApi.product(sku), retry: false });

export const todayQuery = queryOptions({ queryKey: [...STOCK, "today"], queryFn: stockApi.today });

export const issueQuery = (id: string) =>
  queryOptions({ queryKey: [...STOCK, "issue", id], queryFn: () => stockApi.issueRequest(id), retry: false });

export const requestsQuery = (warehouse?: WarehouseCode) =>
  queryOptions({ queryKey: [...STOCK, "requests", warehouse ?? "all"], queryFn: () => stockApi.requests(warehouse) });

export const suggestionsQuery = (warehouse: WarehouseCode) =>
  queryOptions({ queryKey: [...STOCK, "suggestions", warehouse], queryFn: () => stockApi.suggestions(warehouse) });
